module.exports = __webpack_public_path__ + "static/img/visionPic2.ce0c8a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/visionPic2.jpg
// module id = HCFP
// module chunks = 0